import type { NavigateFunction } from "react-router/dist/lib/hooks"

import { RoutesPaths } from "../../../constants/routes.ts"

export const SENT_TO_MOBILE_APP = { sentToMobileApp: true } as const

export const isSentToMobileApp = (payload: unknown): boolean =>
  payload === SENT_TO_MOBILE_APP

export const sendToMobileApp = <T>(
  navigate: NavigateFunction,
  rejectWithValue: (value: typeof SENT_TO_MOBILE_APP) => T
): T => {
  navigate(RoutesPaths.auth.mobileApp, { replace: true })
  return rejectWithValue(SENT_TO_MOBILE_APP)
}
